import { Suspense, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Download } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { useToast } from "@/hooks/useToast"
import { Header } from "@/layouts/header"
import { downloadSofiaFile } from "@/lib/download-file-helper"
import { AgentSkillsTable } from "@/modules/admin/agent-skills/components/agent-skills-table"
import { useAgentSkillsQueryLoader } from "@/modules/admin/agent-skills/services/useAgentSkillsQuery"

const AgentSkills = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const [queryRef, loadQuery] = useAgentSkillsQueryLoader()
  const [isDownloading, setIsDownloading] = useState(false)

  useEffect(() => {
    loadQuery({}, { fetchPolicy: "network-only" })
  }, [loadQuery])

  const handleExportExcel = async () => {
    setIsDownloading(true)
    await downloadSofiaFile({
      endpoint: "api/export/agent-skills",
      fileName: "agent-skills.xlsx",
      onComplete: () => toast({ description: t("admin.agentSkills.export.success") }),
      onError: () => toast({ description: t("admin.agentSkills.export.error") }),
    })
    setIsDownloading(false)
  }

  return (
    <>
      <Header title={t("admin.agentSkills.pageTitle")}>
        <Button className="p-4" isLoading={isDownloading} disabled={isDownloading} onClick={handleExportExcel}>
          <Download size={24} />
          {t("admin.agentSkills.export.label")}
        </Button>
      </Header>
      <div className="grid-cols-1fr-auto bg-background-subdued grid grid-rows-1 pt-8">
        {queryRef && (
          <Suspense fallback={null}>
            <AgentSkillsTable queryRef={queryRef} />
          </Suspense>
        )}
      </div>
    </>
  )
}

export { AgentSkills }
